import { render, staticRenderFns } from "./StaticModal.vue?vue&type=template&id=517ec3e0&scoped=true"
import script from "./StaticModal.vue?vue&type=script&lang=js"
export * from "./StaticModal.vue?vue&type=script&lang=js"
import style0 from "./StaticModal.vue?vue&type=style&index=0&id=517ec3e0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517ec3e0",
  null
  
)

export default component.exports